/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const dropDown = () => {
		if(document.querySelector('.js-news-yearList')) {
			// 最新と最古の年を取得
			const latest = document.querySelector('.js-news-latest-year').textContent;
			const earliest = document.querySelector('.js-news-earliest-year').textContent;
			// ドロップダウンリスト要素を取得
			const yearList = document.querySelector('.js-news-yearList');
			// 現在のパスから年の部分を除いたベースパスを取得
			const currentPath = location.pathname.replace('index.html','');
			const basePath = currentPath.replace(/\d{4}\/?$/, ''); // 末尾の年を削除
			const optionVal = (_num) => {
				// ベースパスに年を追加してパスを生成
				return basePath + _num + `/`;
			};
			
			// HTML側の既存の「最新」オプションに値を設定
			const existingOptions = yearList.querySelectorAll('option');
			existingOptions.forEach(option => {
				if (option.textContent.trim() === '最新' && option.value === '') {
					option.value = basePath; // インデックスページのパス
					// インデックスページの場合はselectedを設定
					if (!currentPath.match(/\d{4}/)) {
						option.selected = true;
					}
				}
			});
			
			// 最新から最古の年までのオプションを生成し追加
			for(var i =latest; i>=earliest; i--) {
				const option = document.createElement('option');
				option.textContent = i.toString();
				option.value = optionVal(i);
				// 現在のパスに年が含まれている場合、一致する年をselected
				if (currentPath.match(/\d{4}/) && currentPath.includes(i.toString())) {
					option.selected = true;
				}
				yearList.appendChild(option);
			}
			// ドロップダウンリストの変更イベントを処理(ボタンの場合)
			// const yearListSubmit = document.querySelector('.js-news-yearList-submit');
			// yearListSubmit.addEventListener('click', function () {
			// 	location.href = yearList.value;
			// });

			// ドロップダウンリストの変更イベントを処理(プルダウンの場合)
			document.querySelector('.js-news-yearList').addEventListener('change', function() {
				location.href = yearList.value;
			});
		}
	};

	// ニュースリストを描画（※ニュース描画が不要な案件では削除）
	const createNews = async () => {
		// htmlをテンプレートとして使用
		let html = await fetch('/cnt_common/js/html/news-list.html').then(res => res.text());

		fetch(cmsNewsJson())
		.then(response => response.json())
		.then((data) => {
			const newsData = data.rt_bn_news;
			if(newsData.length) {
				for(let i=0; i<newsData.length; i++) {
					let _title = newsData[i].rt_cf_n_title.content[0];
					let _category = newsData[i].rt_cf_n_category_name.content[0];
					let _date = newsData[i].rt_cf_n_date.content;
					let _href = newsData[i].rt_cf_n_href;
					let _hrefLink = _href.href;
					let _target = _href.target;
					let _pdf = newsData[i].rt_cf_n_attachment_file_icon_pdf;
					let _pdfSize = newsData[i].rt_cf_n_attachment_file_size;
					let icon = _pdf !== null ? pdfIcon : (_target === '_blank' ? blankIcon : '');
					let pdfSpan = '';
					if(_pdfSize !== null) {
						pdfSpan = `<span class="__file">(PDF:<span class="">${bytesToSize(_pdfSize.content)}</span>)</span>`;
					}

					// UTCのまま出力されている場合はUTC→JSTに変換
					// new Date(_date)

					let isDisable = _hrefLink === '#' ? 'is-disable' : '';

					let thisHtml = html
						.replaceAll('{!href!}', _hrefLink)
						.replaceAll('{!target!}', _target)
						.replaceAll('{!isDisable!}', isDisable)
						.replaceAll('{!date!}', _date)
						.replaceAll('{!category!}', _category)
						.replaceAll('{!title!}', _title)
						.replaceAll('{!pdfSize!}', pdfSpan)
						.replaceAll('{!icon!}', icon)
				}
			}
		});
	}

	// ニュースタグリストのカレント設定
	const setNewsTagCurrent = () => {
		const newsTagList = document.querySelector('.js-newsTagList');
		if (!newsTagList) return;

		// 現在のページパスを取得（末尾のindex.htmlを削除）
		const currentPath = location.pathname.replace('index.html', '');

		// すべてのリンクをチェック
		const links = newsTagList.querySelectorAll('a');
		links.forEach(link => {
			const href = link.getAttribute('href');
			if (href && href === currentPath) {
				link.classList.add('is-current');
			}
		});
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const newsFUNCTIONS = () => {
		dropDown();
		createNews(); // ニュース描画が不要な案件では削除
		setNewsTagCurrent();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { newsFUNCTIONS(); }) : newsFUNCTIONS();

})(window.FUNCTIONS);
